import { createLazyComponent } from '@muse-web/router'

export const AsyncChangeTrackOrderDialogContainer = createLazyComponent(
    () =>
        import(
            /* webpackChunkName: 'dialog-change-track-order' */ './ChangeTrackOrderDialogContainer'
        ),
    'ChangeTrackOrderDialogContainer',
)
